import UserComment from '@/store/models/user/UserComment'

// Shared Vuex ORM mutations for threaded comments, used by both the
// collectionItem (private) and collections (public) store modules.

// Comments + their embedded latest replies as one insertable list —
// Vuex ORM drops unknown nested fields, so latest replies must be inserted explicitly
export function withLatestReplies(comments) {
  return [...comments, ...comments.map(comment => comment.latestReply).filter(Boolean)]
}

export async function adjustParentRepliesCount(parentId, delta) {
  if (!parentId) return
  const parent = UserComment.find(parentId)
  if (!parent) return

  await UserComment.update({
    where: parentId,
    data: { repliesCount: Math.max(0, parent.repliesCount + delta) },
  })
}

// Mirror the server-side thread cascade locally; returns the removed record
// (callers use its parentId/repliesCount for follow-up count adjustments)
export async function removeCommentThreadLocally(commentId) {
  const comment = UserComment.find(commentId)
  await UserComment.delete(commentId)
  await UserComment.delete(record => record.parentId === commentId)
  await adjustParentRepliesCount(comment?.parentId, -1)
  return comment
}

export async function applyCommentLikeState(comment, liked) {
  await UserComment.update({
    where: comment.id,
    data: {
      isLikedByUser: liked,
      likesCount: Math.max(0, comment.likesCount + (liked ? 1 : -1)),
    },
  })
}
